<div
  class="card-header"
  [class]="input_showBorderBottom ? '' : 'border-bottom-0'"
>
  <!------------------------------------  Title  ------------------------------------>
  <div
    class="card-title page-title"
    *ngIf="input_showTitle"
    [style.display]="display"
  >
    <h3 class="card-label">
      <div [ngClass]="input_titleClass" [innerHTML]="input_title | translate"></div>
    </h3>
    <ng-content select="[scheduled-id]"></ng-content>
    <ng-content select="[recipient-count]"></ng-content>
    <ng-content select="[title]"></ng-content>
  </div>

  <!--------------------------------  Default Buttons  -------------------------------->

  <div class="card-toolbar" *ngIf="input_showDefaultBtns">
    <!-- elements before btns -->
    <ng-content select="[before-btns]"></ng-content>

    <!---------------------------  Index Page Default Btns  --------------------------->
    <ng-container *ngIf="!input_isForm">
      <!-- help btn -->
      <a
        *ngIf="input_showHelpBtn"
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-info btn-hover-rise d-print-none"
        mat-ripple
        [matTooltip]="'pages.help.title' | translate"
        (click)="onShowHelpPage()"
      >
        <i class="mdi mdi-help-circle mdi-20px !tw-p-0 text-success"></i>
      </a>

      <!-- audit btn -->
      <a
        *ngIf="
          input_showAuditBtn && permissionService.userState()?.isSuperAdmin
        "
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-info btn-hover-rise d-print-none"
        mat-ripple
        [matTooltip]="'pages.audits.title' | translate"
        (click)="onShowAuditPage()"
      >
        <i class="mdi mdi-eye mdi-20px tw-p-0 text-info"></i>
      </a>

      <!-- refresh btn -->
      <a
        *ngIf="input_showRefreshBtn"
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise d-print-none"
        mat-ripple
        [matTooltip]="'common.refresh' | translate"
        (click)="onReset()"
      >
        <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
      </a>

      <!-- add btn for all users -->
      <a
        *ngIf="input_showAddBtn && !input_showAddBtnOnlyForSuperAdmin"
        [style.opacity]="addBtnLoading ? '0.5' : '1'"
        class="btn txt-lg button-shadow tw-mx-1 tw-flex-center btn-hover-rise d-print-none"
        [themeColor]="'btn'"
        mat-ripple
        (click)="onAdd()"
      >
        <ng-container *ngIf="addBtnLoading">
          <span class="tw-mx-1 d-print-none">{{
            "common.new" | translate
          }}</span>
          <div class="tw-px-[8px] d-print-none">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </ng-container>

        <ng-container *ngIf="!addBtnLoading">
          <span class="tw-mx-1 d-print-none">{{
            "common.new" | translate
          }}</span>
          <i
            class="mdi mdi-plus-circle-outline mdi-18px tw-mx-1 d-print-none tw-text-white dark:tw-text-white"
          ></i>
        </ng-container>
      </a>
      <!-- add btn for super admin -->
      <a
        *ngIf="
          input_showAddBtnOnlyForSuperAdmin &&
          permissionService.userState()?.isSuperAdmin
        "
        class="btn txt-lg button-shadow tw-flex-center tw-mx-1 btn-hover-rise d-print-none"
        [themeColor]="'btn'"
        mat-ripple
        (click)="onAdd()"
      >
        <span class="tw-mx-1">{{ "common.new" | translate }}</span>
        <i class="mdi mdi-plus-circle-outline mdi-18px tw-mx-1"></i>
      </a>
    </ng-container>

    <!--------------------------  Form Page Default Btns  -------------------------->
    <ng-container *ngIf="input_isForm">
      <!-- audit btn -->
      <a
        *ngIf="
          input_showFormAuditBtn && permissionService.userState()?.isSuperAdmin
        "
        class="btn txt-lg button-shadow tw-mx-1 tw-flex-center btn-hover-rise d-print-none"
        [themeColor]="'btn-light-info'"
        mat-ripple
        (click)="onShowFormAuditPage()"
      >
        <span class="tw-mx-1">{{ "pages.audits.title" | translate }}</span>
        <i class="mdi mdi-eye mdi-18px tw-mx-1"></i>
      </a>

      <!-- refresh btn -->
      <a
        *ngIf="input_showRefreshBtn"
        class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise d-print-none"
        mat-ripple
        [matTooltip]="'common.refresh' | translate"
        (click)="onReset()"
      >
        <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
      </a>

      <!-- back btn -->
      <a
        *ngIf="input_showBackBtn"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise d-print-none"
        mat-ripple
        [matTooltip]="'common.back' | translate"
        (click)="onBack()"
      >
        <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
      </a>
    </ng-container>

    <!-- elements after btns -->
    <ng-content select="[after-btns]"></ng-content>
  </div>

  <!--  custom elements -->
  <ng-content select="[custom-elements]"></ng-content>

  <ng-content select="[lastUpdateDatetime]"></ng-content>
</div>

<!-----------------------------------  Loading  ----------------------------------->
<app-loading-bar
  *ngIf="input_showLoadingBar"
  [manualLoading]="input_loading"
></app-loading-bar>
